<div mat-dialog-title>
  <div>{{ data?.title }}</div>
  @if (!noCancel) {
    <i class="fal fa-times global-dialog-close-button" (click)="onCancel()"></i>
  }
</div>

<div mat-dialog-content>
  <div class="sub-title-container">
    <div class="subtitle">
      <div>
        {{ data?.subtitle }}
      </div>
      @if (copySubtitle) {
        <div class="subtitle-copy">
          <lib-copy-to-clipboard-button [value]="data?.subtitle">
          </lib-copy-to-clipboard-button>
        </div>
      }
    </div>
    @if (data?.subtitle2) {
      <div class="subtitle2">
        {{ data?.subtitle2 }}
      </div>
    }
  </div>
</div>

<div mat-dialog-actions>

  @if (!noCancel) {
    <lib-action-button largeButton [kind]="ActionButtonKind.STROKED" label="Cancel" (click)="onCancel()">
    </lib-action-button>
  }

  @if (thirdButtonText) {
    <lib-action-button largeButton [kind]="ActionButtonKind.SECONDARY" [label]="thirdButtonText" (click)="onThirdButton()">
    </lib-action-button>
  }

  @if (secondButtonText) {
    <lib-action-button largeButton [kind]="ActionButtonKind.SECONDARY" [label]="secondButtonText" (click)="onSecondButton()">
    </lib-action-button>
  }

  <lib-action-button largeButton [label]="data.confirmButtonText" (click)="onSubmit()" [kind]="kind">
  </lib-action-button>

</div>
